import styled from "styled-components";

import checkIcon from "../../images/icons/check-gptw.svg";

export const GreatPlaceToWorkWrapper = styled.section`
  max-width: 1344px;
  margin: 0 auto 112px;
  padding: 0 48px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    margin-bottom: 60px;
    padding: 0 24px;
    transform: none;
  }
`;

export const Col = styled.div`
  width: 100%;
  max-width: 528px;
  height: auto;
  margin-left: 80px;
  margin-right: 32px;

  @media (max-width: 767px) {
    min-width: 100%;
    margin-right: 0;
    margin-left: 0;
  }
`;

export const BoxImage = styled.div`
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
  top: 126px;

  @media (max-width: 767px) {
    margin-bottom: 61px;
  }
`;

export const BoxText = styled.div`
  max-width: 435px;
  min-width: 280px;
  border-left: 1px solid #dddddd;
  padding-left: 50px;
  padding-bottom: 64px;

  position: relative;

  ::before {
    content: "";
    display: block;
    position: absolute;
    width: 9px;
    height: 9px;
    background-color: var(--orange);
    border-radius: 50%;
    border: 8px solid #ffffff;
    top: 2px;
    left: -13px;
  }

  @media (max-width: 767px) {
    min-width: 100%;
    padding-bottom: 48px;
    padding-left: 24px;
  }
`;

export const BoxSelo = styled.div`
  h3 {
    display: none;
  }

  @media (max-width: 767px) {
    display: flex;
    width: 100%;
    margin-bottom: 16px;

    h3 {
      display: block;
    }
  }
`;

export const FirstBoxText = styled(BoxText)`
  width: 100%;
  max-width: 515px;
  display: flex;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const BoxImageSelo = styled.div`
  width: 64px;
  margin-right: 33px;

  @media (max-width: 767px) {
    width: 48px;
    margin-right: 24px;
  }
`;

export const Row = styled.div`
  @media (max-width: 767px) {
    h3 {
      display: none;
    }
  }
`;

export const LastBoxText = styled(BoxText)`
  padding-bottom: 0;
  border-left: 1px solid #fff;

  ::before {
    content: url(${checkIcon});
    display: inline-block;
    /* position: absolute; */
    width: 24px;
    height: 24px;
    background-color: #fff;
    border-radius: 50%;
    border: 8px solid #ffffff;
    top: -5px;
    left: -20px;
  }

  p {
    margin-bottom: 48px;
  }

  @media (max-width: 767px) {
    p {
      margin-bottom: 34px;
    }
  }
`;

export const H2 = styled.h2`
  font-size: 36px;
  margin-bottom: 64px;
  font-weight: 800;

  @media (max-width: 767px) {
    font-size: 28px;
    margin-bottom: 24px;
  }
`;

export const H3 = styled.h3`
  font-size: 24px;
  margin-bottom: 8px;
  font-weight: 800;
`;

export const P = styled.p`
  line-height: 28px;
`;
